import BuildMetricsChoice from "../../../utils/BuildMetricsChoice";
import { getDatesInRange, addDays } from "../../../utils/FormatDate";

const colors = [
    "#2196F3",
    "#FF4081",
    "#8BC34A",
    "#FFEB3B",
    "#009688",
    "#7C4DFF",
    "#00BCD4",
    "#FF9800",
    "#4CAF50",
    "#3F51B5",
    "#607D8B",
    "#FF5722",
    "#03A9F4",
    "#795548",
];

const sortObject = (o) =>
    Object.keys(o)
        .sort()
        .reduce((r, k) => ((r[k] = o[k]), r), {});

const getDates = (analytic) => {
    const dateRanges = [];
    for (let key in analytic) {
        let value = analytic[key];
        let dates = Object.keys(value).map((str) => new Date(str));
        dateRanges.push(new Date(Math.min(...dates)));
        dateRanges.push(new Date(Math.max(...dates)));
    }

    const datesPeriods = {
        start: Math.min(...dateRanges),
        end: Math.max(...dateRanges),
    };

    const dates = getDatesInRange(addDays(new Date(datesPeriods.start), -1), datesPeriods.end);

    return dates;
};

const buildDatasetsMetrics = (metric) => {
    const dates = getDates(metric);
    const datasets = Object.keys(metric).map((key, idx) => {
        var row = { ...metric[key] };
        dates.map((date) => (row[date] = row[date] !== undefined ? row[date] : 0));
        row = { ...sortObject(row) };
        const color = colors[idx];
        return {
            id: idx,
            label: key,
            data: row,
            pointRadius: 1,
            borderColor: color,
            backgroundColor: color,
            spanGaps: true,
        };
    });

    return [datasets, dates];
};

const prepareDataMetric = (metrics, metricsChoice, metrics_id) => {
    const metricIndex = metricsChoice.findIndex((metric) => metric.index == metrics_id);
    const metric = metricsChoice[metricIndex];
    var type_metric = "";

    if (metric.value.includes("condition")) {
        type_metric = "conditions";
    }

    if (metric.value.includes("redirection")) {
        type_metric = "redirections";
    }

    const metricsListRedirectionsOrConditions = metrics[type_metric];
    return metricsListRedirectionsOrConditions.filter((row) => row.id == metrics_id).pop();
};

function PrepareDataForDownload(analytics, metrics, type, option, metrics_id) {
    const metricsChoice = BuildMetricsChoice(metrics);
    const data = prepareDataMetric(metrics, metricsChoice, metrics_id);
    return data;
}

function AnalyticsGraphDataFactory(analytics, metrics, type, option, metrics_id) {
    const metricsChoice = BuildMetricsChoice(metrics);

    if (metrics_id != null && type == "metrics" && option == "line") {
        const data = prepareDataMetric(metrics, metricsChoice, metrics_id);

        var [datasets, dates] = buildDatasetsMetrics(data.values);

        return { id: "multi-line", labels: [...dates], datasets: datasets };
    }

    if (metrics_id != null && type == "metrics" && option == "pie") {
        const { values } = prepareDataMetric(metrics, metricsChoice, metrics_id);

        const row = Object.values(values).map((analytic) =>
            Object.values(analytic).reduce((accumulator, value) => accumulator + value)
        );

        return {
            id: "pie",
            labels: Object.keys(values),
            datasets: [{ label: "test", data: row, borderColor: colors, backgroundColor: colors }],
        };
    }

    if (type == "metrics") {
        type = "number_of_messages";
    }

    const data = analytics[type];
    return {
        id: type,
        labels: getDates(data),
        datasets: [
            {
                label: type,
                data: data,
                borderColor: "rgb(14, 122, 237, 0.8)",
                pointBackgroundColor: "rgb(14, 122, 237, 0.8)",
                pointRadius: 1,
                backgroundColor: "rgb(14, 122, 237, 0.6)",
                spanGaps: true,
            },
        ],
    };
}

export { AnalyticsGraphDataFactory, PrepareDataForDownload };
